(function() {
    'use strict';

    angular
        .module('invesfleet')
        .controller('BaseFormController', BaseFormController);
    

    BaseFormController.$inject = [
        '$stateParams',
        'baseFlotaService',
        'genericDataService',
        '$filter',
        '$state',
        '$rootScope',
        'notificationService',
        '$scope',
        'common'
    ];

    function BaseFormController($stateParams, baseFlotaService, genericDataService,
        $filter, $state, $rootScope, notificationService, $scope, common){

        var watchers;
        watchers = $scope.$$watchers;
        $scope.$$watchers = [];

        var id = $stateParams.id;

        /* PUBLIC VARIABLES */
        var vm = this;
        vm.stateParams = $stateParams;
        vm.procesoInicializacion = true;

        vm.base = {};
        vm.timesIgnore = 0; 
        vm.edit = false;
        vm.genericData = {
            provinces: {
                list: null,
                selected: { id: null }
            },
            pais: {
                list: null,
                selected: { id: null }
            },
            poblaciones: {
                list: null,
                selected: { id: null }
            },
            calendarios: {
                list: null, 
                selected: {id: null}
            },
            empresas: {
                list: null,
                selected: { id: null }
            },
            tipo: {
                list: [
                    {
                        id: 0,
                        nombre: 'Fisica'
                    },
                    {
                        id: 1,
                        nombre: 'Virtual'
                    }
                ],
                selected: {
                    id: 0,
                    nombre: 'Fisica'
                }
            }
        };

        vm.save = save;
        vm.saveAndClose = saveAndClose;
        vm.saveAndNew = saveAndNew;
        vm.onPaisChange = onPaisChange;
        vm.onProvinciaChange = onProvinciaChange;
        vm.effectClass = effectClass;
        vm.resizable = resizable;
        vm.onAddressChange = onAddressChange; 
        vm.clearDir = clearDir; 
        vm.showEditIcon = showEditIcon;
        vm.hideEditIcon = hideEditIcon;
        vm.showEditIconValue = false;
        
        vm.accionSaveList = [
            {
                accionTexto: 'Guardar y cerrar',
                accion: vm.saveAndClose,
                selected: computeValueAccionSelected('guardarCerrar')
            },
            {
                accionTexto: 'Guardar y nuevo',
                accion: vm.saveAndNew,
                selected: computeValueAccionSelected('saveAndNew')
            },
            {
                accionTexto: 'Guardar',
                accion: vm.save,
                selected: computeValueAccionSelected('save')
            },
        ];

        /* INITIALIZER */
        (function () {

            //Edit
            if (id != null) {
                vm.edit = true;
                baseFlotaService.getById(id)
                    .then(function (base) {
                        vm.base = base;
                        if (vm.base.tipo === 1) {
                            vm.genericData.tipo.selected = vm.genericData.tipo.list[1];
                        }
                        getGenericData();
                    });
            }
            //New
            else {
                getGenericData();
            }
        })();

        function computeValueAccionSelected(accion) {
            if (accion === vm.stateParams.accion) { return true; }
            return false;
        }

        function getGenericData() {
            genericDataService.getPaises()
                .then(function (res) {
                    vm.genericData.pais.list = res;
                    var modelPais = vm.genericData.pais.list.find(pais => {
                        return pais.nombre === vm.base.pais
                    })

                    if (!common.isNullOrUndefined(modelPais)) {
                        vm.genericData.pais.selected = modelPais;
                    }
                    else {
                        vm.genericData.pais.selected = vm.genericData.pais.list[0];
                    }
                    selectChanged(vm.genericData.pais.list, vm.genericData.pais.selected, false);
                    genericDataService.getProvinces(null, vm.genericData.pais.selected.id)
                        .then(function (res) {
                            vm.genericData.provinces.list = res;
                            var modelProvincia = vm.genericData.provinces.list.find(provincia => {
                                return provincia.nombre === vm.base.provincia
                            })

                            if (!common.isNullOrUndefined(modelProvincia)) {
                                vm.genericData.provinces.selected = modelProvincia;
                            }
                            else {
                                vm.genericData.provinces.selected = vm.genericData.provinces.list[0];
                            }
                            selectChanged(vm.genericData.provinces.list, vm.genericData.provinces.selected, false);
                            genericDataService.getPopulations(null, vm.genericData.provinces.selected.id)
                                .then(function (res) {
                                    vm.genericData.poblaciones.list = res;
                                    var modelPoblacion = findByProperty(vm.genericData.poblaciones.list, 'nombre', vm.base.poblacion);
                                    if (modelPoblacion) {
                                        vm.genericData.poblaciones.selected = modelPoblacion;
                                    }
                                    else {
                                        vm.genericData.poblaciones.selected = vm.genericData.poblaciones.list[0];
                                    }
                                    selectChanged(vm.genericData.poblaciones.list, vm.genericData.poblaciones.selected, false);
                                    setTimeout(function () { vm.procesoInicializacion = false; }, 3000);
                                });
                        });
                });

            genericDataService.getCalendarios()
                .then(function (res) {
                    vm.genericData.calendarios.list = res;
                    var calendario = findByProperty(vm.genericData.calendarios.list,
                        'id', vm.base.calendarioId);
                    if (calendario) {
                        vm.genericData.calendarios.selected = calendario;
                    }
                    else {
                        vm.genericData.calendarios.selected = vm.genericData.calendarios.list[0];
                    }
                });

            genericDataService.getEmpresas()
                .then(function (res) {
                    vm.genericData.empresas.list = res;
                    var modelEmpresas = findByProperty(vm.genericData.empresas.list, 'id', vm.driver.empresaId);
                    if (modelEmpresas) {
                        vm.genericData.empresas.selected = modelEmpresas;
                    }
                    else {
                        vm.genericData.empresas.selected = vm.genericData.empresas.list[0];
                    }
                });
        }

        function clearDir() {
            vm.base.direccion = null;
            vm.genericData.pais.selected = vm.genericData.pais[0];
            vm.genericData.provinces.selected = vm.genericData.provinces[0];
            vm.genericData.poblaciones.selected = vm.genericData.poblaciones[0];;
            vm.base.cp = null;
            vm.base.longitud = null;
            vm.base.latitud = null;
        }

        function doSave(action) {
            if (vm.edit && (vm.base.id === null || vm.base.id === '' || vm.base.id === undefined)) {
                sendErrorRequire();
                return;
            }
            vm.base.pais = vm.genericData.pais.selected.nombre;
            vm.base.provincia = vm.genericData.provinces.selected.nombre;
            vm.base.poblacion = vm.genericData.poblaciones.selected.nombre;
            vm.base.calendarioId = vm.genericData.calendarios.selected.id;
            vm.base.tipo = vm.genericData.tipo.selected.id; 
            vm.base.empresaId = vm.genericData.empresas.selected.id;

            baseFlotaService.add(vm.base).then(function (baseSave) {
                sendSAveNotification();
                vm.edit = true;
                if (action === 'saveAndClose') {
                    $state.go('flota.configuracion.listadoBases');
                }
                else if (action === 'saveAndNew') {
                    $state.go('flota.configuracion.nuevo', { 'accion': 'saveAndNew' });
                }
                else {
                    vm.base.id = baseSave.id;
                    vm.base.operarioId = baseSave.operarioId;
                }
            });
        }

        function save() {
            var action = 'save';
            for (var i = 0; i < vm.accionSaveList.length; ++i) {
                if (vm.accionSaveList[i].accionTexto === 'Guardar') { vm.accionSaveList[i].selected = true; }
                else { vm.accionSaveList[i].selected = false; }
            }
            doSave(action);
        }

        function saveAndClose() {
            var action = 'saveAndClose';
            doSave(action);
        }

        function saveAndNew() {
            for (var i = 0; i < vm.accionSaveList.length; ++i) {
                if (vm.accionSaveList[i].accionTexto === 'Guardar y nuevo') { vm.accionSaveList[i].selected = true; }
                else { vm.accionSaveList[i].selected = false; }
            }
            var action = 'saveAndNew';
            doSave(action);
        }

        function sendSAveNotification() {
            notificationService.sendAppNotification({
                message: 'El operario se ha guardado correctamente',
                positionY: 'top', positionX: 'right', delay: 3000, type: 'info'
            });
        }

        function sendErrorRequire() {
            notificationService.sendAppNotification({
                message: 'El campo Id es obligatorio',
                positionY: 'top', positionX: 'right', delay: 3000, type: 'error'
            });
        }

        function selectChanged(list, selected, requireId) {
            requireId = (typeof requireId === 'undefined') ? true : requireId; //RequireId defaults to TRUE
            if (!list || !selected) { return; } //If the is no list or element exit
            if (list.length <= 0 || selected.id == null) { // Delete element unless it doesnt require id
                if (!requireId) { return; }
                selected.nombre = null;
                selected.id = null;
                return;
            }
            var find = findByProperty(list, 'id', selected.id);
            if (find) {
                selected.nombre = find.nombre;
                selected.id = find.id;
            } else {
                selected.nombre = null;
                selected.id = null;
            }
        }

        function findByProperty(array, property, id) {
            if (array === null) { return null; }
            for (var i = 0; i < array.length; i++) {
                if (array[i][property] === id) {
                    return array[i];
                }
            }
            return null;
        }

        function onPaisChange() {
            if (!vm.procesoInicializacion) {
                var p = vm.genericData.pais.selected && vm.genericData.pais.selected.id;
                getProvincias(p);
            }
        }

        function getProvincias(pais) {
            if (pais == null) {
                vm.genericData.provinces.list = null;
            }
            else {
                genericDataService.getProvinces(null, pais)
                    .then(function (res) {
                        vm.genericData.provinces.list = res;
                        selectChanged(vm.genericData.provinces.list, vm.genericData.provinces.selected);

                        if (vm.genericData.provinces.id == null) {
                            vm.genericData.provinces.selected = vm.genericData.provinces.list[0];
                        }
                    });
            }
        }

        function onProvinciaChange() {
            if (!vm.procesoInicializacion) {
                var p = vm.genericData.provinces.selected && vm.genericData.provinces.selected.id;
                getPoblaciones(p);
            }
        }

        function getPoblaciones(poblacion) {
            if (poblacion == null) { vm.genericData.poblaciones.list = null; }
            else {
                genericDataService.getPopulations(null, poblacion)
                    .then(function (res) {
                        vm.genericData.poblaciones.list = res;
                        selectChanged(vm.genericData.poblaciones.list, vm.genericData.poblaciones.selected);

                        if (vm.genericData.poblaciones.id == null) {
                            vm.genericData.poblaciones.selected = vm.genericData.poblaciones.list[0];
                        }
                    });
            }
        }

        function effectClass(target) {
            vm.effects = {};
            vm.effects[target] = true;
            setTimeout(function () {
                vm.effects[target] = undefined;
            }, 3000);
        }

        function resizableInput(el, factor) {
            var int = Number(factor) || 7.7;
            function resize() { el.style.width = ((el.value.length + 1) * int) + 'px'; }
            var e = 'keyup,keypress,focus,blur,change'.split(',');
            for (var i in e) { el.addEventListener(e[i], resize, false); }
            resize();
        }

        function resizable() {
            resizableInput(document.getElementById('txt'), 7);
        }

        function showEditIcon(e) {
            vm.showEditIconValue = true;
        }

        function hideEditIcon(e) {
            if (!$(e.currentTarget).is(":focus"))
                vm.showEditIconValue = false;
        }

        function onAddressChange(address) {
            vm.base.cp = address.cp;
            var watchers = $scope.$$watchers;
            $scope.$$watchers = [];

            if (!common.isNullOrUndefined(address.country)) {
                vm.genericData.pais.selected.nombre = address.country.toUpperCase();
            }

            if (!common.isNullOrUndefined(address.state)) {
                vm.genericData.provinces.selected.nombre = address.state.toUpperCase();
            }

            if (!common.isNullOrUndefined(address.city)) {
                vm.genericData.poblaciones.selected.nombre = address.city.toUpperCase();
            }

            $scope.$$watchers = watchers;

        }

      




    }

})();

